import { useState, useEffect } from "react";
import apiService from "../../services/apiService";
import "../../styles/settings/ProfileModal.css";

const ProfileModal = ({ onClose }) => {
  const [profile, setProfile] = useState(null);
  const [contact, setContact] = useState("");
  const [loading, setLoading] = useState(true);

  /* ================= FETCH PROFILE ================= */
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await apiService.get("/admin/users/profile/me"); // ✅ FIXED
        setProfile(res.data);
        setContact(res.data.contact_number || "");
      } catch (err) {
        console.error(err);
        alert("Failed to load profile");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  /* ================= UPDATE CONTACT ================= */
  const handleSave = async () => {
    try {
      await apiService.put(`/admin/users/${profile.user_id}`, { // ✅ FIXED
        contact_number: contact,
      });

      alert("Contact number updated successfully");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to update contact number");
    }
  };

  const handleResetPassword = () => {
    window.location.href = "/forgot-password";
  };

  if (loading || !profile) {
    return <div className="profile-backdrop">Loading profile...</div>;
  }

  return (
    <div className="profile-backdrop">
      <div className="profile-card">
        <div className="profile-header">
          <h3>PROFILE</h3>
        </div>

        <div className="profile-grid">
          <div className="field">
            <label>User ID</label>
            <input value={profile.user_id} disabled />
          </div>

          <div className="field">
            <label>Name</label>
            <input value={profile.user_name} disabled />
          </div>

          <div className="field">
            <label>Email</label>
            <input value={profile.email} disabled />
          </div>

          <div className="field">
            <label>Role</label>
            <input value={profile.role} disabled />
          </div>

          <div className="field">
            <label>User Status</label>
            <input
              value={profile.user_status === 1 ? "Active" : "Inactive"}
              disabled
            />
          </div>

          <div className="field">
            <label>Contact (Editable)</label>
            <input
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
          </div>
        </div>

        <div className="profile-actions">
          <button className="save-btn" onClick={handleSave}>
            Save
          </button>
          <button className="reset-btn" onClick={handleResetPassword}>
            Reset Password
          </button>
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
